import { render, staticRenderFns } from "./FacebookMessengerChat.container.vue?vue&type=template&id=536a146c&scoped=true&"
import script from "./FacebookMessengerChat.container.vue?vue&type=script&lang=js&"
export * from "./FacebookMessengerChat.container.vue?vue&type=script&lang=js&"
import style0 from "./FacebookMessengerChat.container.vue?vue&type=style&index=0&id=536a146c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536a146c",
  null
  
)

export default component.exports